import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "config" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_5 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "period" }, "Chu kỳ khoảng thời gian", -1)
const _hoisted_7 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { for: "max_book_at_one" }, "Số lượng đăng ký tối đa", -1)
const _hoisted_9 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "date_start_at" }, "Bắt đầu ngày khám lúc", -1)
const _hoisted_11 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "date_end_at" }, "Kết thúc ngày khám lúc", -1)
const _hoisted_13 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "lunch_start" }, "Kết thúc ca sáng", -1)
const _hoisted_15 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "lunch_end" }, "Bắt đầu ca chiều", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quill_editor = _resolveComponent("quill-editor")
  const _component_Panel = _resolveComponent("Panel")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Panel, { header: "Hiện địa chỉ" }, {
      default: _withCtx(() => [
        _createVNode(_component_quill_editor, {
          value: $setup.appConfig.address,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ($setup.appConfig.address = $event))
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    _hoisted_2,
    _createVNode(_component_Panel, { header: "Hiện thông báo" }, {
      default: _withCtx(() => [
        _createVNode(_component_quill_editor, {
          value: $setup.appConfig.notice,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ($setup.appConfig.notice = $event))
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_Dropdown, {
          id: "period",
          modelValue: $setup.appConfig.period,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.appConfig.period = $event)),
          options: $setup.periods,
          optionLabel: "display",
          optionValue: "value",
          placeholder: "Chọn khoảng thời gian"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_InputNumber, {
          modelValue: $setup.appConfig.max_book_at_one,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.appConfig.max_book_at_one = $event)),
          id: "max_book_at_one",
          min: 1,
          max: 60,
          step: 1,
          showButtons: ""
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_Calendar, {
          id: "date_start_at",
          modelValue: $setup.appConfig.date_start_at,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($setup.appConfig.date_start_at = $event)),
          stepMinute: 5,
          showTime: true,
          timeOnly: true,
          hourFormat: "12",
          dateFormat: "hh:mm"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_Calendar, {
          id: "date_end_at",
          modelValue: $setup.appConfig.date_end_at,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.appConfig.date_end_at = $event)),
          stepMinute: 5,
          showTime: true,
          timeOnly: true,
          hourFormat: "12",
          dateFormat: "hh:mm"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_component_Calendar, {
          id: "lunch_start",
          modelValue: $setup.appConfig.lunch_start,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ($setup.appConfig.lunch_start = $event)),
          stepMinute: 5,
          showTime: true,
          timeOnly: true,
          hourFormat: "12",
          dateFormat: "hh:mm"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_Calendar, {
          id: "lunch_end",
          modelValue: $setup.appConfig.lunch_end,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ($setup.appConfig.lunch_end = $event)),
          stepMinute: 5,
          showTime: true,
          timeOnly: true,
          hourFormat: "12",
          dateFormat: "hh:mm"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_Button, {
      label: "Lưu tùy chọn",
      icon: "pi pi-check",
      onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.saveConfig()))
    })
  ]))
}